import { jsx as i, jsxs as p } from "react/jsx-runtime";
import * as g from "react";
import { P as f, c as y } from "../index-D8UDu4KA.js";
import '../Progress.css';var c = "Progress", d = 100, [R] = y(c), [$, M] = R(c), x = g.forwardRef(
  (r, e) => {
    const {
      __scopeProgress: o,
      value: t = null,
      max: a,
      getValueLabel: h = E,
      ...N
    } = r;
    (a || a === 0) && !m(a) && console.error(V(`${a}`, "Progress"));
    const s = m(a) ? a : d;
    t !== null && !v(t, s) && console.error(w(`${t}`, "Progress"));
    const n = v(t, s) ? t : null, I = u(n) ? h(n, s) : void 0;
    return /* @__PURE__ */ i($, { scope: o, value: n, max: s, children: /* @__PURE__ */ i(
      f.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": u(n) ? n : void 0,
        "aria-valuetext": I,
        role: "progressbar",
        "data-state": _(n, s),
        "data-value": n ?? void 0,
        "data-max": s,
        ...N,
        ref: e
      }
    ) });
  }
);
x.displayName = c;
var b = "ProgressIndicator", P = g.forwardRef(
  (r, e) => {
    const { __scopeProgress: o, ...t } = r, a = M(b, o);
    return /* @__PURE__ */ i(
      f.div,
      {
        "data-state": _(a.value, a.max),
        "data-value": a.value ?? void 0,
        "data-max": a.max,
        ...t,
        ref: e
      }
    );
  }
);
P.displayName = b;
function E(r, e) {
  return `${Math.round(r / e * 100)}%`;
}
function _(r, e) {
  return r == null ? "indeterminate" : r === e ? "complete" : "loading";
}
function u(r) {
  return typeof r == "number";
}
function m(r) {
  return u(r) && !isNaN(r) && r > 0;
}
function v(r, e) {
  return u(r) && !isNaN(r) && r <= e && r >= 0;
}
function V(r, e) {
  return `Invalid prop \`max\` of value \`${r}\` supplied to \`${e}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${d}\`.`;
}
function w(r, e) {
  return `Invalid prop \`value\` of value \`${r}\` supplied to \`${e}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${d} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var A = x, C = P;
const D = "_value_1hxi2_32", L = "_progressWrapper_1hxi2_45", S = "_progressRoot_1hxi2_51", W = "_progressIndicator_1hxi2_52", l = {
  value: D,
  progressWrapper: L,
  progressRoot: S,
  progressIndicator: W
};
function O(r, e) {
  if (!Number.isFinite(r)) return 0;
  const o = typeof e == "number" && e > 0 ? e : 100, t = o === 100 ? r : r / o * 100;
  return Math.min(100, Math.max(0, Math.round(t * 1e4) / 1e4));
}
const F = ({ disabled: r = !1, ...e }) => {
  !e["aria-label"] && !e["aria-labelledby"] && !e.title && console.warn("Progress component must provide and `aria-label`, `aria-labelledby` or `title` attribute ");
  const { max: o, value: t } = e;
  if (typeof t != "number") return null;
  const a = O(t, o);
  return /* @__PURE__ */ p("div", { className: l.progressWrapper, "data-cxy-name": "progress", "data-disabled": r, children: [
    /* @__PURE__ */ p("p", { className: l.value, children: [
      a,
      "%"
    ] }),
    /* @__PURE__ */ i(A, { className: l.progressRoot, ...e, children: /* @__PURE__ */ i(
      C,
      {
        className: l.progressIndicator,
        style: { transform: `translateX(-${100 - a}%)` }
      }
    ) })
  ] });
};
export {
  F as Progress
};
